import React, { useState } from 'react';
import { FiUploadCloud } from 'react-icons/fi';

const Ocrsupport = () => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleImageChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected);
    setPreview(URL.createObjectURL(selected));
  };

  const parseOcrText = (text) => {
    const lines = text.split('\n').map(line => line.trim()).filter(Boolean);

    let billNo = '';
    let orderNo = '';
    let billDate = '';
    let billAmount = '';
    let customerName = '';
    // let contact = '';

    lines.forEach(line => {
      if (!billNo && /Iny\s*No\s*([^\s]+)/i.test(line)) {
        const match = line.match(/Iny\s*No\s*([^\s]+)/i);
        if (match) billNo = match[1];
      }

      if (!orderNo && /ORD\s*No\s*([^\s]+)/i.test(line)) {
        const match = line.match(/ORD\s*No\s*([^\s]+)/i);
        if (match) orderNo = match[1];
      }

      if (!billDate && /Date[:\s]+(\d{2}\/\d{2}\/\d{2})/i.test(line)) {
        const match = line.match(/Date[:\s]+(\d{2}\/\d{2}\/\d{2})/i);
        if (match) billDate = match[1];
      }

      if (!billAmount && /Bill Amount\s+([\d.]+)/i.test(line)) {
        const match = line.match(/Bill Amount\s+([\d.]+)/i);
        if (match) billAmount = `₹${match[1]}`;
      }

      if (!customerName && /Ltd|Pvt/i.test(line)) {
        customerName = line;
      }

    //   if (!contact && /\b\d{10}\b/.test(line)) {
    //     contact = line.match(/\b\d{10}\b/)[0];
    //   }
    });

    return {
      billNo: billNo || 'N/A',
      orderNo: orderNo || 'N/A',
    //   contact: contact || 'N/A',
      customerName: customerName || 'N/A',
      billDate: billDate || 'N/A',
      billAmount: billAmount || 'N/A',
    };
  };

  const handleSubmit = async (e) => {

    setLoading(true);
    e.preventDefault();
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await fetch("/server/ocrfunction/ocrfunction", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      console.log("Extracted Text:", data.extractedText);
      const parsed = parseOcrText(data.extractedText);
      setTableData([parsed]);
      setLoading(false);
    } catch (error) {
      console.error("OCR failed:", error);
    }
  };

  return (
<>

{loading && (
 <div className="fixed inset-0 flex items-center justify-center bg-white/60 z-[9999]">
 <div className="animate-spin rounded-full h-12 w-12 border-4 border-red-500 border-t-transparent"></div>
</div>
)}

    <div className="max-w-4xl mx-auto mt-10 p-6 bg-white rounded-xl shadow-lg">
      <h2 className="text-3xl font-bold text-center mb-6 text-[#EF7320]">
        Upload Bill for OCR
      </h2>

      <form onSubmit={handleSubmit} className="space-y-6">
        <label
          htmlFor="upload"
          className="flex flex-col items-center justify-center w-full p-6 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-[#EF7320]"
        >
          <FiUploadCloud size={40} className="text-gray-400 mb-2" />
          <p className="text-gray-500">{file ? file.name : "Click to upload bill image"}</p>
          <input
            type="file"
            id="upload"
            accept="image/*"
            onChange={handleImageChange}
            className="hidden"
          />
        </label>

        {preview && (
          <div className="text-center">
            <img src={preview} alt="Preview" className="h-52 inline-block rounded shadow" />
          </div>
        )}

        <button
          type="submit"
          className="w-full bg-[#EF7320] text-white font-medium py-2 px-4 rounded hover:bg-orange-600"
        >
          Submit for OCR
        </button>
      </form>

      {tableData.length > 0 && (
        <div className="mt-8">
          <h3 className="text-xl font-semibold mb-4">Extracted Bill Info</h3>
          <div className="overflow-x-auto">
            <table className="w-full border text-left">
              <thead className="bg-[#EF7320] text-white">
                <tr>
                  <th className="px-4 py-2">Bill No</th>
                  <th className="px-4 py-2">Order No</th>
                  <th className="px-4 py-2">Customer Name</th>
                  {/* <th className="px-4 py-2">Contact</th> */}
                  <th className="px-4 py-2">Bill Date</th>
                  <th className="px-4 py-2">Bill Amount</th>
                </tr>
              </thead>
              <tbody className="bg-gray-100 text-gray-700">
                {tableData.map((item, idx) => (
                  <tr key={idx}>
                    <td className="px-4 py-2">{item.billNo}</td>
                    <td className="px-4 py-2">{item.orderNo}</td>
                    <td className="px-4 py-2">{item.customerName}</td>
                    {/* <td className="px-4 py-2">{item.contact}</td> */}
                    <td className="px-4 py-2">{item.billDate}</td>
                    <td className="px-4 py-2">{item.billAmount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
</>


  );
};

export default Ocrsupport;
